import type {
  InsertDepartmentTypeGroupByNameMutation,
  InsertDepartmentTypeGroupByNameMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertDepartmentTypeGroupByNameDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useInsertDepartmentTypeGroupByName = createMutationHook({
  name: 'insertDepartmentTypeGroupByName',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.department.insertTypeGroupByName.mutationOptions({
      onSuccess,
    }),
  mapInput: (
    variables: InsertDepartmentTypeGroupByNameMutationVariables
  ): { Name: string } => {
    if (!variables.Name) {
      throw new Error('Name is required');
    }

    return { Name: variables.Name };
  },
  invalidate: (trpc) => [
    trpc.frontend.department.departmentTypeGroups.queryKey(),
  ],
  mapResponse: (result: {
    Id: string;
  }): InsertDepartmentTypeGroupByNameMutation => ({
    insert_department_type_group_one: {
      __typename: 'department_type_group',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertDepartmentTypeGroupByNameDocument,
  graphqlVariables: (
    variables: InsertDepartmentTypeGroupByNameMutationVariables
  ) => ({ ...variables }),
  evictFields: ['department_type_group'],
});
